import { PORTAL_VERSION_FOOTER } from './portalVersion';

export interface UnifiedFooterProps {
  copyright?: string;
  versionLabel?: string;
  className?: string;
}

export function UnifiedFooter({
  copyright: _copyright,
  versionLabel = PORTAL_VERSION_FOOTER,
  className,
}: UnifiedFooterProps) {
  return (
    <footer
      className={className}
      style={{
        height: versionLabel ? '28px' : '12px',
        minHeight: versionLabel ? '28px' : '12px',
        maxHeight: versionLabel ? '28px' : '12px',
        borderTop: '1px solid hsl(220 13% 91%)',
        background: 'radial-gradient(ellipse 120% 120% at center, rgba(135, 206, 250, 0.08) 0%, rgba(135, 206, 250, 0.12) 50%, rgba(135, 206, 250, 0.15) 80%, rgba(135, 206, 250, 0.05) 100%)',
        position: 'relative',
        flexShrink: 0,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* 모서리 주위 blur 효과 */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'radial-gradient(ellipse 100% 100% at center, transparent 0%, transparent 60%, rgba(135, 206, 250, 0.1) 80%, rgba(135, 206, 250, 0.2) 100%)',
          backdropFilter: 'blur(2px)',
          pointerEvents: 'none',
        }}
      />
      {versionLabel ? (
        <span
          style={{
            position: 'relative',
            zIndex: 1,
            fontSize: '11px',
            color: 'hsl(220 9% 46%)',
            letterSpacing: '0.02em',
          }}
        >
          {versionLabel}
        </span>
      ) : null}
    </footer>
  );
}
